import AppData from "../model/AppData";
import AppUtils from "./apputlis";

function ToName(props, path, data) {
    //获取域名
    let baseUrl = window.location.origin;
    let pathname = window.location.pathname;
    baseUrl = `${baseUrl}${pathname}#`

    console.log('baseUrl', baseUrl);
    //测试本地域名
    // baseUrl = 'http://192.168.8.126:3000/#' 

    if (window.android && window.android.toWeb) {
        window.android.toWeb(baseUrl + path, data)
    } else if (window && window.webkit && window.webkit.messageHandlers && AppData.os == 'ios') {
        let str = JSON.stringify({ path: baseUrl + path, data: data })
        window.webkit.messageHandlers.ToNewWeb.postMessage(str);
    } else {
        props.history.push({ pathname: path, data: data });
    }
}

function OpenBrowser(url) {
    if (window.android && window.android.toBrowser) {
        window.android.toWeb(url)
    } else if (window && window.webkit && window.webkit.messageHandlers && AppData.os == 'ios') {
        let str = JSON.stringify({ path: url })
        window.webkit.messageHandlers.ToOutsideWeb.postMessage(str);
    } else {
        AppUtils.openUrl(url);
    }
}

function ToLogin(props, platfrom = 'h5') {
    if (window.android && window.android.toBrowser) {
        window.android.toLogin()
    } else if (window && window.webkit && window.webkit.messageHandlers && platfrom == 'ios') {
        window.webkit.messageHandlers.ToLogin.postMessage("");
    } else {
        props.history.push('/login');
    }
}

function ToBack(platfrom = 'h5') {
    if (window && window.webkit && window.webkit.messageHandlers && platfrom == 'ios') {
        window.webkit.messageHandlers.VCBack.postMessage('');
    } else {
        window.history.back();
    }
}

function JumpPlay(props, room_id, match_type, match_id, data) {
    let os = 'h5';
    if (AppData.os !== '') {
        os = AppData.os
    }
    let token = 0;

    if (AppData.me.token !== '') {
        token = AppData.me.token
    }

    let customerId = 0
    if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
        customerId = AppData.me.customer_id
    }
    let uid = AppUtils.getStorageItem('uid');
    let fastkey = AppUtils.getStorageItem("fastkey");
    let roomIp = AppUtils.getStorageItem("roomIp");
    let roomPort = AppUtils.getStorageItem("roomPort");
    let fid = AppData.me.free_id;
    ToName(props, `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}/${fid}`, data)
}

export {
    JumpPlay,
    ToName,
    OpenBrowser,
    ToLogin,
    ToBack
};
export default ToName